// pipe: 4A.6 — Records sidebar entry (links to the universal ERP records screen).
import { useI18n } from '@affine/i18n';
import { DatabaseTableViewIcon } from '@blocksuite/icons/rc';
import { useServices } from '@toeverything/infra';

import { MenuLinkItem } from '../../modules/app-sidebar/views';
import { WorkbenchService } from '../../modules/workbench';
import { useNavPrefixActive } from './use-nav-prefix-active';

export const RecordsButton = () => {
  const t = useI18n();
  const { workbenchService } = useServices({ WorkbenchService });
  const workbench = workbenchService.workbench;
  const active = useNavPrefixActive(workbench, '/records', true);

  return (
    <MenuLinkItem
      icon={<DatabaseTableViewIcon />}
      active={active}
      to={'/records'}
    >
      <span data-testid="pipe-records-nav">
        {t['com.affine.pipe.records.nav']()}
      </span>
    </MenuLinkItem>
  );
};
